<template>
  <div class="card flex h-full w-full flex-col justify-between justify-items-center gap-8 hover:-translate-y-1">
    <div class="flex h-full flex-col items-center gap-8">
      <div class="badge h-fit w-fit bg-mauve-500 font-segoe-bold text-eerie-black-500">{{ name }}</div>
      <div class="space-y-1 text-center">
        <h3 class="font-exo-bold text-5xl">{{ formattedPrice }}</h3>
        <p v-if="price > 0" class="text-lg text-eerie-black-100">per month</p>
      </div>
      <div class="mt-auto space-y-3">
        <p class="text-eerie-black-200">{{ description }}</p>
        <hr class="w-full text-eerie-black-200" />
        <div class="space-y-3 text-eerie-black-200">
          <div v-for="(feature, idx) in features" :key="idx" class="flex gap-2">
            <div><CircleCheck class="h-4 w-4 text-spring-green-500" /></div>
            <p class="leading-none">{{ feature }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { CircleCheck } from 'lucide-vue-next';

export default {
  name: 'VibePlanCard',
  components: {
    CircleCheck,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    price: {
      type: [Number, String],
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    features: {
      type: Array,
      required: true,
    },
  },
  computed: {
    formattedPrice() {
      if (this.price <= 0) {
        return '$0.00';
      }
      return `$${Number(this.price).toFixed(2)}`;
    },
  },
};
</script>
